export default "__VITE_ASSET__BDGD6uon__"